export enum FilterValues {
    all = 'all',
    volatile = 'volatile',
    stable = 'stable',
    concentrated = 'concentrated',
    classic = 'classic',
}

export enum MyLiquidityUrlParams {
    filter = 'filter',
}

export const FilterOptions = [
    { label: 'All', value: FilterValues.all },
    { label: 'Stable', value: FilterValues.stable },
    { label: 'Volatile', value: FilterValues.volatile },
    { label: 'Concentrated', value: FilterValues.concentrated },
    { label: 'Classic', value: FilterValues.classic },
];
